<template>
    <div class="page-body">
        <div class="table-body">
            <div class="table-header">
                <div class="handle-box">
                    <table style="width: 100%">
                        <tr>
                            <td style="width: 80px;text-align: right">
                                合同编号：
                            </td>
                            <td style="width: 28%;">
                                <el-input v-model="searchItem.contractNum" size="small"
                                          placeholder="请输入合同编号"></el-input>
                            </td>
                            <td style="width: 80px;text-align: right">
                                公司名称：
                            </td>
                            <td style="width: 28%;">
                                <el-input v-model="searchItem.companyName" size="small" placeholder="请输入公司名称"
                                ></el-input>
                            </td>
                            <td style="width: 80px;text-align: right">
                                销售人员：
                            </td>
                            <td style="width: 28%">
                                <el-select v-model="searchItem.userName" size="small"
                                           style="width: 100%"
                                           filterable
                                           placeholder="请选择销售人员">
                                    <el-option
                                            v-for="item in saleList"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 80px;padding-top: 10px;text-align: right">
                                项目名称：
                            </td>
                            <td style="width: 28%;  padding-top: 10px">
                                <el-input v-model="searchItem.projectName" size="small" placeholder="请输入项目名称"></el-input>
                            </td>
                            <td style="width: 80px; padding-top: 10px;text-align: right">
                                合同类型：
                            </td>
                            <td style="width: 28%">
                                <template>
                                    <el-select v-model="searchItem.contractType" size="small"
                                               style="padding-top: 10px;width: 100%"
                                               placeholder="请选择合同类型">
                                        <el-option
                                                v-for="item in contractTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </td>
                            <td style="width: 80px; padding-top: 10px;text-align: right">
                                公司类型：
                            </td>
                            <td style="width: 28%">
                                <template>
                                    <el-select v-model="searchItem.companyType" size="small"
                                               style="padding-top: 10px;width: 100%"
                                               placeholder="请选择公司类型">
                                        <el-option
                                                v-for="item in unitTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 80px;padding-top: 10px;text-align: right">
                                生成时间：
                            </td>
                            <td style="width: 28%;padding-top: 10px">
                                <el-date-picker
                                        v-model="searchItem.startDate"
                                        type="date"
                                        size="small"
                                        placeholder="选择日期时间"
                                        style="width: 47%;"
                                        class="handle-input-date"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                                至
                                <el-date-picker
                                        v-model="searchItem.endDate"
                                        type="date"
                                        placeholder="选择日期时间"
                                        size="small"
                                        style="width: 47%;"
                                        class="handle-input-date"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </td>
                            <td style="width: 80px;padding-top: 10px;text-align: right">
                                审批状态：
                            </td>
                            <td>
                                <template>
                                    <el-select v-model="searchItem.auditState" size="small"
                                               style="padding-top: 10px;width: 100%"
                                               placeholder="请选择审批状态">
                                        <el-option
                                                v-for="item in approvalStatuses"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </td>
                            <td colspan="2" style="padding-top: 10px;text-align: center">
                                <!--<el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel">导出为Excel文件</el-button>
                                -->
                                <el-button type="primary" icon="el-icon-search" size="small"
                                           @click="searchBtn">搜索
                                </el-button>
                                <el-button type="primary" icon="el-icon-refresh-right" style="margin-left: 25%"
                                           size="small" @click="resetBtn">重置
                                </el-button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="table-info">
                <div class="table-button">
                    <div style="width: 100%">
                        <el-table
                                :data="tableData"
                                style="width: 100%;height: 100%;"
                                :max-height="tableHeight"
                                :border="true"
                                :header-cell-style="{ background: '#EBEEF8',height: '45px', 'text-align':'center' }"
                                :cell-style="{padding:'0',height: lineHeight}">
                            <el-table-column type="index" label="序号" width="50"
                                             align="center"></el-table-column>
                            <el-table-column prop="contractNum" label="合同编号" width="160" align="center"
                                             show-overflow-tooltip></el-table-column>
                            <el-table-column prop="contractType" label="合同类型" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.contractType == 0">销售合同</span>
                                    <span v-else-if="scope.row.contractType == 1">技术服务合同</span>
                                    <span v-else-if="scope.row.contractType == 2">部件买卖合同</span>
                                    <span v-else-if="scope.row.contractType == 3">售后合同</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="userName" label="销售人员" width="110"
                                             align="center"></el-table-column>
                            <el-table-column prop="userTel" label="联系电话" width="110"
                                             align="center"></el-table-column>
                            <el-table-column label="应收账款(元)" width="120" align="right" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.contractReceivables == 0">0</span>
                                    <span v-else-if="scope.row.contractReceivables == null">0</span>
                                    <span v-if="scope.row.contractReceivables != 0">{{(scope.row.contractReceivables/100).toFixed(2)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="companyName" label="公司名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="companyType" label="公司类型" width="80" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.companyType == 0">建机厂</span>
                                    <span v-else-if="scope.row.companyType == 1">国企</span>
                                    <span v-else-if="scope.row.companyType == 2">租赁商</span>
                                    <span v-else-if="scope.row.companyType == 3">代理商</span>
                                    <span v-else-if="scope.row.companyType == 4">集团公司</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="projectName" label="项目名称" width="140" show-overflow-tooltip
                                             align="left">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.projectName == ''">无</span>
                                    <span v-else>{{scope.row.projectName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="towerCount" label="塔机数量" width="80"
                                             align="center"></el-table-column>
                            <el-table-column prop="lifterCount" label="升降机数量" width="100"
                                             align="center"></el-table-column>
                            <el-table-column prop="auditState" label="审批状态" width="80" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.auditState == 0">草稿</span>
                                    <span v-else-if="scope.row.auditState == -1" style="color: red">已驳回</span>
                                    <span v-else-if="scope.row.auditState == 10" style="color: green">已通过</span>
                                    <span v-else-if="scope.row.auditState == 5" style="color: #F0AD4E">待发货</span>
                                    <span v-else style="color: blue">审批中</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="生成时间" width="110" :formatter="dateFormat"
                                             align="center" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="uploadFile" label="上传附件" width="90" align="center"
                                             show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.auditState == 10" type="text"
                                               @click="uploadFiles(scope.row.id)">上传附件
                                    </el-button>
                                    <el-button v-if="scope.row.auditState != 10" type="text" disabled>上传附件</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="发货单" width="70" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.contractType == 2" type="text" disabled></el-button>
                                    <el-button v-else-if="scope.row.auditState == 10 && scope.row.contractType != 2" type="text"
                                               @click="shippingShow(scope.row.id)">发货单
                                    </el-button>
									<el-button v-else type="text" disabled>发货单</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <div class="opertion">
                                        <i class="iconfont iconbianji" title="编辑合同"
                                           v-if="scope.row.auditState == 0 && hasAuthority('contract_formal_update')
                                           || scope.row.auditState == -1 &&  hasAuthority('contract_formal_update') "
                                           @click="editContract(scope.row.id)"></i>
                                        <i class="iconfont iconxiangqing" title="查看详情"
                                           @click="showContract(scope.row.id)"></i>
                                        <i class="iconfont icontongguo" title="提交申请"
                                           v-if="scope.row.auditState == 0 && hasAuthority('contract_formal_apply_audit') || scope.row.auditState == -1 && hasAuthority('contract_formal_apply_audit')"
                                           @click="submitContract(scope.row.id)"></i>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="table-data">
                    <Pagination :pageSize="option.pageSize" :pageTotal="totalPage" :pageCurrent.sync="option.pageIndex"
                                :pageList="pageList" @handlePageChange="pageChange" @handleSizeChange="pageSizeChange"/>
                </div>
            </div>
        </div>
        <div class="data-dialog">
            <el-dialog
                    :title="editTitle"
                    :visible.sync="dialogVisible"
                    width="70%"
                    :close-on-click-modal="isClose"
                    style="margin-top: -90px"
                    center>
                <div class="dialog-body">
                    <div class="basic-info">
                        <div class="text-title">
                            基础信息
                        </div>
                        <div>
                            <el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="100px"
                                     class="demo-ruleForm">
                                <el-form-item size="small" label="合同名称:" prop="contractName">
                                    <el-input size="small" v-model.trim="contractForm.contractName"></el-input>
                                </el-form-item>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="合同号:" prop="contractNum">
                                            <el-input size="small" v-model="contractForm.contractNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="公司名称:" prop="companyName">
                                            <el-input size="small" v-model="contractForm.companyName"
                                                      disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="公司类型:" prop="unitType">
                                            <el-select v-model="contractForm.companyType" style="width: 100%" disabled
                                                       placeholder="请选择公司类型">
                                                <el-option
                                                        v-for="item in unitTypes"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="设备类型:" prop="deviceType"
                                                      style="text-align: center">
                                            <span v-if="contractForm.deviceType == 0">普通型</span>
                                            <span v-else>加强型</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="塔机数量:" prop="towerCount">
                                            <el-input size="small" disabled v-model.number="contractForm.towerCount"
                                                      autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="升降机数量:" prop="lifterCount">
                                            <el-input size="small" disabled v-model.number="contractForm.lifterCount"
                                                      autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="应收账款(元):" prop="contractReceivables">
                                            <el-input size="small" type="number" v-model.number="contractForm.contractReceivables"
                                                      autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="合同类型:" prop=" lifterCount">
                                            <el-select v-model="contractForm.contractType" style="width: 100%"
                                                       placeholder="请选择合同类型">
                                                <el-option
                                                        v-for="item in contractTypes"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="是否安装:" prop="isInstall"
                                                      style="text-align: center">
                                            <span v-if="contractForm.isInstall == 1">是</span>
                                            <span v-else>否</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="项目名称:" prop="projectName"
                                                      style="text-align: center">
                                            <span>{{contractForm.projectName}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" label="开始日期:" prop="startDate">
                                            <el-date-picker
                                                    v-model="contractForm.startDate"
                                                    type="date"
                                                    style="width: 100%"
                                                    placeholder="选择日期时间"
                                                    value-format="yyyy-MM-dd">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10" style="width: 50%">
                                        <el-form-item size="small" style="width: 100%" label="截止日期:" prop="endDate">
                                            <el-date-picker
                                                    v-model="contractForm.endDate"
                                                    type="date"
                                                    style="width: 100%"
                                                    :picker-options="pickerEndDate"
                                                    placeholder="选择日期时间"
                                                    value-format="yyyy-MM-dd">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item size="small" label="收费政策:" prop="chargePolicy">
                                    <el-input type="textarea" size="small" :rows="3"
                                              v-model.trim="contractForm.chargePolicy"></el-input>
                                </el-form-item>
                                <el-form-item size="small" label="特殊政策及发货说明:" prop="specialPolicy">
                                    <el-input type="textarea" size="small" :rows="3"
                                              v-model.trim="contractForm.specialPolicy"></el-input>
                                </el-form-item>
                                <el-form-item size="small" label="备注:" prop="remark">
                                    <el-input type="textarea" size="small" :rows="3"
                                              v-model="contractForm.remark"></el-input>
                                </el-form-item>
                            </el-form>
                            <table style="text-align: left;">
                                <tr v-if="contractForm.contractType != 2">
                                    <td style="width: 92px">功能需求：</td>
                                    <td colspan="5">
                                        <div class="td-body">
                                            <table cellpadding="0" cellspacing="0" style="width: 100%">
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        序号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.index}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;text-overflow:ellipsis;padding: 3px; text-align: center">
                                                        塔机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        升降机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        特殊型号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td>部件需求：</td>
                                    <td colspan="5" style="padding: 10px 0">
                                        <div class="td-body">
                                            <table cellpadding="0" cellspacing="0" style="width: 100%">
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        部件名称
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in componentItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in componentItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <template>
                                <el-table
                                        :data="basicTable"
                                        style="width: 100%"
                                        :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                                        :cell-style="{padding:'0',height: '41px'}">
                                    <el-table-column type="index" label="序号" width="50px"
                                                     align="center"></el-table-column>
                                    <el-table-column prop="deviceCategory" label="设备类型" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.deviceCategory == 1">升降机</span>
                                            <span v-else>塔机</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sizeModel" label="规格型号" align="center"></el-table-column>
                                    <el-table-column prop="siteNum" label="现场编码" align="center"></el-table-column>
                                    <el-table-column prop="stringDiameter" label="钢丝绳直径(mm)"
                                                     align="center"></el-table-column>
                                    <el-table-column prop="armLength" label="前臂长度(m)" align="center"></el-table-column>
									<el-table-column prop="rearArmLength" label="后臂长度(m)" align="center"></el-table-column>
                                    <el-table-column prop="maxLoad" label="最大载重(T)" align="center"></el-table-column>
                                    <el-table-column prop="deviceType" label="类型" align="center"></el-table-column>
                                    <el-table-column prop="isNeedCard" label="是否需要视频流量卡" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedCard == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="isNeedModel" align="center" label="是否需要现场调试多塔防碰撞功能">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedModel == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                    </div>
                    <div class="approval-table">
                        <div class="text-title">
                            审批历史
                        </div>
                        <template>
                            <el-table
                                    :data="approvalRecord"
                                    border
                                    style="width: 100%">
                                <el-table-column prop="depName" label="部门"></el-table-column>
                                <el-table-column prop="userName" label="审批人"></el-table-column>
                                <el-table-column prop="auditRemark" label="意见">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.auditRemark == null">无</span>
                                        <span v-else>{{scope.row.auditRemark}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="时间" :formatter="dateFormat">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.createTime == null">无</span>
                                        <span v-else>{{scope.row.createTime}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isPass == 0 && scope.row.isEffective == 1"
                                              style="color: red">驳回</span>
                                        <span v-else-if="scope.row.isPass == 0 && scope.row.isEffective == 0"
                                              style="color: #F08080">驳回</span>
                                        <span v-else-if="scope.row.isPass == 1 && scope.row.isEffective == 1"
                                              style="color: green">通过</span>
                                        <span v-else-if="scope.row.isPass == 1 && scope.row.isEffective == 0"
                                              style="color: #98FB98">通过</span>
                                        <span v-else style="color: blue">未审批</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <div class="file-info">
                        <div class="text-title">
                            附件信息及下载
                        </div>
                        <div class="down-file">
                            <ol>
                                <li v-for="(file,index) in files" :key="index">
                                    <a :href="urlFilePath + 'erp' + file.attachmentUrl">{{file.attachmentName}}</a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancel('contractForm')">取 消</el-button>
                    <el-button type="primary" :loading="isDisabled"
                               @click="saveContract('contractForm')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="upload-dialog">
            <Upload @openDialog="openDialog" :fileId="contractId" :fileType="uploadType"
                    :dialogVisibles="dialogVisibles"/>
        </div>
        <div class="shipping-dialog">
            <el-dialog
                    title="发货单据详情"
                    :visible.sync="shippingVisible"
                    width="70%"
                    style="margin-top: -80px"
                    :close-on-click-modal="false"
                    center>
                <el-table
                        :data="shippingData"
                        style="width: 100%;height: 100%;"
                        :border="true"
                        :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                        :cell-style="{padding:'0',height: '41px'}">
                    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                    <el-table-column prop="outListNum" label="发货单据" width="150" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="发货时间" width="120" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="sendUser" label="操作人员" width="140" align="center"></el-table-column>
                    <el-table-column prop="sendCount" label="发货数量" width="110" align="center"></el-table-column>
                    <el-table-column label="物料详情" width="140" show-overflow-tooltip align="center">
                        <template slot-scope="scope">
                            <span>SIM卡{{scope.row.sendCount}}张，IMEI型号{{scope.row.sendCount}}个</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="receivingUser" label="发货对象" width="100" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="receivingUserTel" label="收件人电话" width="100" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="receivingAddress" label="发货地址" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <!--  <el-table-column label="发货状态" width="100"  align="center">
                          <template slot-scope="scope">
                              <span v-if="scope.row.status == true" style="color: green">已发货</span>
                              <span v-if="scope.row.status != true" style="color: red">未发货</span>
                          </template>
                      </el-table-column>
                      <el-table-column prop="remark" label="备注"  align="center" show-overflow-tooltip></el-table-column>
                      -->
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="shippingVisible = false">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="information">
            <el-dialog
                    :close-on-click-modal="false"
                    :title="showTitle"
                    :visible.sync="infoVisible"
                    width="70%"
                    style="margin-top: -110px"
                    center>
                <div class="dialog-body">
                    <div class="basic-info">
                        <div class="text-title">
                            基础信息
                        </div>
                        <div>
                            <table style="text-align: left;width: 100%">
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        公司名称：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.companyName}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">合同号：</td>
                                    <td style="width: 330px">
                                        {{contractForm.contractNum}}
                                    </td>
                                    <td style="padding: 5px;width: 100px">合同类型：</td>
                                    <td style="width: 330px">
                                        {{contractForm.contractType == 0?"销售合同":contractForm.contractType == 1?"技术服务合同":contractForm.contractType == 2?'部件买卖合同':contractForm.contractType == 3?"售后合同":'未知合同'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        公司类型：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.companyType==0?'建机厂':(contractForm.companyType==1?'国企':(contractForm.companyType==2?'租赁商':(contractForm.companyType==3?'代理商':'集团公司')))}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">塔机数量：</td>
                                    <td style="width: 330px">
                                        {{contractForm.towerCount}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">升降机数量：</td>
                                    <td style="width: 330px">
                                        {{contractForm.lifterCount}}
                                    </td>

                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 120px">应收账款(元)：</td>
                                    <td style="width: 330px">
                                        {{contractForm.contractReceivables==0?0:(contractForm.contractReceivables/100).toFixed(2)}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">
                                        是否安装：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.isInstall == 1?'是':'否'}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">
                                        项目名称：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.projectName}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        服务周期(月)：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.startDate}}~{{contractForm.endDate}}
                                    </td>
                                    <td style="padding: 5px;width: 80px">
                                        设备类型：
                                    </td>
                                    <td style="width: 330px;">
                                        {{contractForm.deviceType == 0?'普通型':'加强型'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        收费政策：
                                    </td>
                                    <td colspan="5">
                                        {{contractForm.chargePolicy}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        特殊政策及发货说明：
                                    </td>
                                    <td colspan="5">
                                        {{contractForm.specialPolicy}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 5px;width: 80px">
                                        备注：
                                    </td>
                                    <td colspan="5">
                                        {{contractForm.remark}}
                                    </td>
                                </tr>
                                <tr v-if="contractForm.contractType != 2">
                                    <td>功能需求：</td>
                                    <td colspan="5">
                                        <div class="td-body">
                                            <table cellpadding="0" cellspacing="0" style="width: 100%">
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        序号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.index}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        塔机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in towerItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        升降机
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in lifterItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        特殊型号
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in specialItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td>部件需求：</td>
                                    <td colspan="5" style="padding: 10px 0">
                                        <div class="td-body">
                                            <table cellpadding="0" cellspacing="0" style="width: 100%">
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px; text-align: center">
                                                        部件名称
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in componentItems"
                                                        style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        {{item.text}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border: 1px solid #EBEEF8;padding: 3px;text-align: center">
                                                        数量
                                                    </td>
                                                    <td :key="i" v-for="(item,i) in componentItems"
                                                        style="text-align: center;border: 1px solid #EBEEF8;padding: 3px;">
                                                        {{item.quality}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <template>
                                <el-table
                                        border
                                        :data="basicTable"
                                        style="width: 100%"
                                        :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                                        :cell-style="{padding:'0',height: '41px'}">
                                    <el-table-column type="index" label="序号" width="50px"
                                                     align="center"></el-table-column>
                                    <el-table-column prop="deviceCategory" label="设备类型" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.deviceCategory == 1">升降机</span>
                                            <span v-else>塔机</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sizeModel" align="center" label="规格型号"></el-table-column>
                                    <el-table-column prop="siteNum" align="center" label="现场编码"></el-table-column>
                                    <el-table-column prop="stringDiameter" align="center"
                                                     label="钢丝绳直径(mm)"></el-table-column>
                                    <el-table-column prop="armLength" align="center" label="前臂长度(m)"></el-table-column>
									<el-table-column prop="rearArmLength" align="center" label="后臂长度(m)"></el-table-column>
                                    <el-table-column prop="maxLoad" align="center" label="最大载重(T)"></el-table-column>
                                    <el-table-column prop="deviceType" align="center" label="类型"></el-table-column>
                                    <el-table-column prop="isNeedCard" label="是否需要视频流量卡" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedCard == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="isNeedModel" align="center" label="是否需要现场调试多塔防碰撞功能">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.isNeedModel == 1">是</span>
                                            <span v-else>否</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                    </div>
                    <div class="payment-table">
                        <div class="text-title">
                            回款信息
                        </div>
                        <template>
                            <el-table
                                    :data="collectionRecord"
                                    border
                                    style="width: 100%"
                                    :header-cell-style="{ background: '#EBEEF8',height: '50px', 'text-align':'center' }"
                                    :cell-style="{padding:'0',height: '41px'}">
                                <el-table-column prop="createTime" label="时间" :formatter="dateFormat"
                                                 align="center"></el-table-column>
                                <el-table-column prop="recoveriesAmount" label="回款金额(元)" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.recoveriesAmount == 0">0</span>
                                        <span v-else>{{(scope.row.recoveriesAmount/100).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="invoiceAmount" label="开票金额(元)" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.invoiceAmount == 0">0</span>
                                        <span v-else>{{(scope.row.invoiceAmount/100).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="contractReceivables" label="合同应收款(元)" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.contractReceivables == 0">0</span>
                                        <span v-else>{{(scope.row.contractReceivables/100).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="recoveriesAmountSum" label="累计回款(元)" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.recoveriesAmountSum == 0">0</span>
                                        <span v-else>{{(scope.row.recoveriesAmountSum/100).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <div class="approval-table">
                        <div class="text-title">
                            审批记录
                        </div>
                        <template>
                            <el-table
                                    :data="approvalRecord"
                                    border
                                    style="width: 100%">
                                <el-table-column prop="depName" label="部门"></el-table-column>
                                <el-table-column prop="userName" label="审批人"></el-table-column>
                                <el-table-column prop="auditRemark" label="意见">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.auditRemark == null">无</span>
                                        <span v-else>{{scope.row.auditRemark}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="时间" :formatter="dateFormat">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.createTime == null">无</span>
                                        <span v-else>{{scope.row.createTime}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isPass == 0 && scope.row.isEffective == 1"
                                              style="color: red">驳回</span>
                                        <span v-else-if="scope.row.isPass == 0 && scope.row.isEffective == 0"
                                              style="color: #F08080">驳回</span>
                                        <span v-else-if="scope.row.isPass == 1 && scope.row.isEffective == 1"
                                              style="color: green">通过</span>
                                        <span v-else-if="scope.row.isPass == 1 && scope.row.isEffective == 0"
                                              style="color: #98FB98">通过</span>
                                        <span v-else style="color: blue">未审批</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <div class="file-info">
                        <div class="text-title">
                            附件信息及下载
                        </div>
                        <div class="down-file">
                            <div class="file-type">
                                <div style="width: 8%;padding: 10px">
                                    设备型号清单:
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <a :href="urlFilePath + 'erp' + contractForm.deviceListUrl">
                                        {{contractForm.deviceListUrl==null?'':contractForm.deviceListUrl.split("/").slice(-1)+
                                        ''}}
                                    </a>
                                </div>
                            </div>
                            <div class="file-type">
                                <div style="width: 8%;padding: 10px">
                                    项目信息清单:
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <a :href="urlFilePath + 'erp' + contractForm.projectMsgUrl">
                                        {{contractForm.projectMsgUrl==null?'':contractForm.projectMsgUrl.split("/").slice(-1)+
                                        ''}}
                                    </a>
                                </div>
                            </div>
                            <div class="file-type">
                                <div style="width: 8%;padding: 10px">
                                    其它附件:
                                </div>
                                <div style="width: 87%;padding: 12px">
                                    <a :href="urlFilePath + 'erp' + contractForm.otherAttachUrl">
                                        {{contractForm.otherAttachUrl==null?'':contractForm.otherAttachUrl.split("/").slice(-1)+
                                        ''}}
                                    </a>
                                </div>
                            </div>
                            <ol>
                                <li v-for="(file,index) in files" class="file-list" :key="index">
                                    <div style="width: 60%">
                                        <a :href="urlFilePath + 'erp' + file.attachmentUrl">{{file.attachmentName}}</a>
                                    </div>
                                    <div style="width: 20%">
                                        <span>{{changeDateFormat(file.createTime)}}</span>
                                    </div>
                                    <div style="width: 10%">
                                        <span>{{file.createUserName}}</span>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="infoVisible = false">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="export">
            <el-dialog
                    title="审批记录"
                    :close-on-click-modal="false"
                    :visible.sync="exportDialogVisible"
                    width="52.6%" center>
                <download-excel
                        class="export-excel-wrapper"
                        :data="json_data"
                        :fields="json_fields"
                        :name="fileName">
                    <!--                    <el-table-->
                    <!--                            :data="tableData"-->
                    <!--                            max-height="400px"-->
                    <!--                            size="small"-->
                    <!--                            row-class-name="row"-->
                    <!--                            cell-class-name="column"-->
                    <!--                            :highlight-current-row="true"-->
                    <!--                            fit>-->
                    <!--                        <el-table-column-->
                    <!--                                v-for="(item, index) in jsonFields"-->
                    <!--                                :key="index"-->
                    <!--                                :prop="item.prop"-->
                    <!--                                :width="item.width"-->
                    <!--                                :label="item.label" show-overflow-tooltip>-->
                    <!--                        </el-table-column>-->
                    <!--                    </el-table>-->
                    <!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
                    <el-button type="primary" size="small" style="margin-left: 48%;margin-top: 1%"
                    >导出数据
                    </el-button>
                </download-excel>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import contract from '../../../public/json/contract.json'
    import shipping from '../../../public/json/shipping.json'
    import funOptions from '../../../public/json/funOptions.json'
    import amount from '../../../public/json/amount.json'
    import approval from '../../../public/json/approval.json'
    import basicData from '../../../public/json/basicData.json'

    export default {
        data() {
            return {
                pageList: [14, 20, 30, 50],
                specialItems: [],
                saleList: [],
                tableHeight: '',
                showTitle: '',
                urlFilePath: process.env.VUE_APP_CURENV,
                files: [],
                contractId: [],
                jsonFields: [
                    /* {label: '', width: '40', prop: 'id'},*/
                    {label: '合同编号', width: '120', prop: 'contractNum'},
                    {label: '合同类型', width: '120', prop: 'contractType'},
                    {label: '销售人员', width: '120', prop: 'userName'},
                    {label: '应收账款(元)', width: '120', prop: 'contractReceivables'},
                    {label: '公司名称', width: '120', prop: 'companyName'},
                    {label: '公司类型', width: '120', prop: 'companyType'},
                    {label: '当前状态', width: '120', prop: 'auditStates'},
                ],
                fileName: '',
                fields: [],
                values: [],
                json_fields: {},
                json_data: [],
                json_meta: [
                    [
                        {
                            " key ": " charset ",
                            " value ": " utf- 8 "
                        }
                    ]
                ],
                towerItems: [],
                lifterItems: [],
                componentItems: [],
                exportDialogVisible: false,
                basicTable: [],
                collectionRecord: [],
                approvalRecord: [],
                checkAll: false,
                currentPage: 0,
                functions: [],
                funNameList: [],
                isIndeterminate: true,
                dialogVisibles: false,
                shippingVisible: false,
                infoVisible: false,
                multipleSelection: [],
                uploadType: '',
                delList: [],
                exportData: [],
                // totalPage:0,
                searchItem: {
                    contractNum: '',
                    userName: '',
                    userTel: '',
                    companyName: '',
                    companyType: '',
                    projectName: '',
                    contractType: '',
                    auditState: '',
                    startDate: '',
                    endDate: '',
                    pageSize: 14,
                    pageIndex: 1
                },
                totalPage: 30,
                dialogVisible: false,

                option: {
                    pageIndex: 1,
                    pageSize: 14,
                    currentPage: 1
                },
                contractTypes: [
                    {
                        label: '销售合同',
                        value: 0
                    },
                    {
                        label: '技术服务合同',
                        value: 1
                    },
                    {
                        label: '部件买卖合同',
                        value: 2
                    },
                    {
                        label: '售后合同',
                        value: 3
                    },
                ],
                approvalStatuses: [
                    {
                        label: '草稿',
                        value: 0
                    },
                    {
                        label: '已通过',
                        value: 10
                    },
                    {
                        label: '已驳回',
                        value: -1
                    },
                    {
                        label: '审批中',
                        value: 1
                    },

                ],
                unitTypes: [
                    {
                        label: '建机厂',
                        value: 0
                    },
                    {
                        label: '国企',
                        value: 1
                    },
                    {
                        label: '租赁商',
                        value: 2
                    },
                    {
                        label: '代理商',
                        value: 3
                    },
                    {
                        label: '集团公司',
                        value: 4
                    },
                ],
                UpDialogVisible: false,
                tableData: [],
                shippingData: [],
                contractForm: {
                    contractName: '',
                    contractNum: '',
                    companyName: '',
                    companyType: '',
                    projectName: '',
                    projectMsgUrl: '',
                    deviceListUrl: '',
                    otherAttachUrl: '',
                    towerCount: '',
                    lifterCount: '',
                    remark: '',
                    endDate: '',
                    startDate: '',
                    isInstall: '',
                    contractType: '',
                    chargePolicy: '',
                    specialPolicy: '',
                    contractReceivables: '',
                    deviceType: '',
                    id: ''
                },
                rules: {
                    contractName: [{required: true, message: '合同名称不能为空', trigger: 'blur'}],
                    contractNum: [{required: true, message: '合同号不能为空', trigger: 'blur'}],
                    companyName: [{required: true, message: '公司名称不能为空', trigger: 'blur'}],
                    chargePolicy: [{required: true, message: '收费政策不能为空', trigger: 'blur'}],
                    specialPolicy: [{required: true, message: '特殊政策及发货说明不能为空', trigger: 'blur'}],
                },
                isClose: false,
                editTitle: '',
                lineHeight: '',
                isDisabled: false,
                pickerEndDate: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
            }
        },
        methods: {
            saveContract(formName) {
                this.isDisabled = true
                this.$refs[formName].validate(item => {
                    if (item) {
                        var contractData = JSON.parse(JSON.stringify(this.contractForm));
                        contractData.contractReceivables = contractData.contractReceivables * 100
                        this.$api.updateContract(contractData).then(res => {
                            if (res.code == 200) {
                                this.pageChange(this.currentPage);
                                this.dialogVisible = false;
                                this.$message.success(res.message);
                                this.isDisabled = false
                            } else {
                                this.$message.error(res.message);
                                this.isDisabled = false
                            }
                        })
                    } else {
                        this.$message.error("请检查数据是否填写完整");
                        this.isDisabled = false
                    }
                })
            },
            cancel(formName) {
                this.contractForm = {
                    contractName: '',
                    contractNum: '',
                    companyName: '',
                    companyType: '',
                    towerCount: '',
                    lifterCount: '',
                    isInstall: '',
                    contractType: '',
                    chargePolicy: '',
                    specialPolicy: '',
                    contractReceivables: 0,
                    deviceType: '',
                    id: ''
                }
                this.$refs[formName].resetFields();
                this.dialogVisible = false;
            },
            shippingShow(id) {
                this.shippingVisible = true;
                this.$api.getContractShipping({id: id}).then(res => {
                    if (res.code == 200) {
                        this.shippingData = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            pageChange(option) {
                if(option != "refresh"){
                    this.option.pageIndex = option;
                    this.searchItem.pageIndex = option;
                }
                this.currentPage = option;
                this.$api.pageContract(this.searchItem).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.content;
                        this.totalPage = res.data.totalElements;
                    } else {
                        this.$message.error("连接服务器失败，请联系管理员")
                    }
                })
            },
            pageSizeChange(val) {
                this.searchItem.pageSize = val;
                this.$api.pageContract(this.searchItem).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.content;
                        this.totalPage = res.data.totalElements;
                    }
                })
            },
            chooseSelection(val) {
                this.multipleSelection = val;
            },
            editContract(id) {
                this.dialogVisible = true;
                this.towerItems = [];
                this.lifterItems = [];
                this.componentItems = [];
                this.$api.getContract({id}).then(res => {
                    if (res.code == 200) {
                        this.contractForm = {
                            contractName: res.data.contractName,
                            contractNum: res.data.contractNum,
                            companyName: res.data.companyName,
                            companyType: res.data.companyType,
                            startDate: res.data.startDate,
                            remark: res.data.remark,
                            endDate: res.data.endDate,
                            towerCount: res.data.towerCount,
                            lifterCount: res.data.lifterCount,
                            isInstall: res.data.isInstalled,
                            projectName: res.data.projectName,
                            contractType: res.data.contractType,
                            chargePolicy: res.data.chargePolicy,
                            specialPolicy: res.data.specialPolicy,
                            contractReceivables: res.data.contractReceivables / 100,
                            deviceType: res.data.deviceType,
                            id: res.data.id
                        };
                        this.basicTable = res.data.deviceList;
                        this.editTitle = '编辑《' + res.data.contractNum + '》合同信息';
                        var towerItemsStr = res.data.towerMap;
                        if (towerItemsStr) {
                            var funcItem = {};
                            var index = 1
                            for (var i in towerItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.index = index;
                                funcItem.quality = towerItemsStr[i];
                                this.towerItems.push(funcItem);
                                index = index + 1
                            }
                        }
                        var lifterItemsStr = res.data.lifterMap;
                        if (lifterItemsStr) {
                            var funcItem = {};
                            for (var i in lifterItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = lifterItemsStr[i];
                                this.lifterItems.push(funcItem);
                            }
                        }
                        var specialItemsStr = res.data.specialMap;
                        if (specialItemsStr) {
                            var funcItem = {};
                            for (var i in specialItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = specialItemsStr[i];
                                this.specialItems.push(funcItem);
                            }
                        }
                        var componentItemsStr = res.data.componentMap;
                        if (componentItemsStr) {
                            var funcItem = {};
                            for (var i in componentItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text =  i;
                                funcItem.quality = componentItemsStr[i];
                                this.componentItems.push(funcItem);
                            }
                        }
                        this.approvalRecord = res.data.auditList;
                    } else {
                        this.$message.error(res.message)
                    }
                })

            },
            submitContract(id) {
                this.$confirm('你确定要提交此合同信息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$api.passContract({id: id, isPass: 1}).then(res => {
                        if (res.code == 200) {
                            this.pageChange("refresh");
                            this.$message.success(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {
                })
            },
            exportExcel() {
                this.exportDialogVisible = true;
                this.fileName = "合同列表";
                this.exportData = [];
                this.searchItem.pageSize = 1000;
                this.$api.pageContract(this.searchItem).then(res => {
                    for (var i = 0; i < res.data.content.length; i++) {
                        res.data.content[i].contractReceivables = res.data.content[i].contractReceivables / 100;
                        this.exportData.push(res.data.content[i]);
                    }
                })
            },
            dateFormat(row, column) {
                let data = row[column.property]
                let dt = new Date(data)
                var year = dt.getFullYear();
                var month = (dt.getMonth() + 1) < 10 ? 0 + '' + (dt.getMonth() + 1) : ((dt.getMonth() + 1))
                var date = dt.getDate() < 10 ? 0 + '' + dt.getDate() : (dt.getDate())
                return year + '-' + month + '-' + date
            },
            changeDateFormat(data) {
                let dt = new Date(data)
                var year = dt.getFullYear();
                var month = (dt.getMonth() + 1) < 10 ? 0 + '' + (dt.getMonth() + 1) : ((dt.getMonth() + 1))
                var date = dt.getDate() < 10 ? 0 + '' + dt.getDate() : (dt.getDate())
                return year + '-' + month + '-' + date
            },
            searchBtn() {
                this.pageChange(1)
            },
            uploadFiles(id) {
                this.uploadType = 'contract';
                this.dialogVisibles = true;
                this.contractId = id;
            },
            openDialog(val) {
                this.dialogVisibles = val;
            },
            showContract(id) {
                this.infoVisible = true;
                this.towerItems = [];
                this.lifterItems = [];
                this.specialItems = [];
                this.componentItems = [];
                this.$api.getContract({id}).then(res => {
                    if (res.code == 200) {
                        this.contractForm = {
                            contractName: res.data.contractName,
                            contractNum: res.data.contractNum,
                            companyName: res.data.companyName,
                            companyType: res.data.companyType,
                            endDate: res.data.endDate,
                            remark: res.data.remark,
                            startDate: res.data.startDate,
                            towerCount: res.data.towerCount,
                            lifterCount: res.data.lifterCount,
                            projectName: res.data.projectName,
                            projectMsgUrl: res.data.projectMsgUrl,
                            deviceListUrl: res.data.deviceListUrl,
                            otherAttachUrl: res.data.otherAttachUrl,
                            isInstall: res.data.isInstalled,
                            contractType: res.data.contractType,
                            chargePolicy: res.data.chargePolicy,
                            specialPolicy: res.data.specialPolicy,
                            contractReceivables: res.data.contractReceivables,
                            deviceType: res.data.deviceType,
                            id: res.data.id
                        };
                        this.showTitle = '《' + res.data.contractNum + '》详情信息'
                        this.basicTable = res.data.deviceList;
                        this.files = res.data.attachmentList;
                        for (var item of res.data.recoveriesRecordList) {
                            item.invoiceAmount = res.data.invoiceAmount;
                            item.contractReceivables = res.data.contractReceivables;
                        }
                        this.collectionRecord = res.data.recoveriesRecordList;
                        this.approvalRecord = res.data.auditList;
                        this.editTitle = '编辑《' + res.data.contractNum + '》合同信息';
                        var towerItemsStr = res.data.towerMap;
                        if (towerItemsStr) {
                            var funcItem = {};
                            var index = 1
                            for (var i in towerItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.index = index;
                                funcItem.quality = towerItemsStr[i];
                                this.towerItems.push(funcItem);
                                index = index + 1
                            }
                        }
                        var lifterItemsStr = res.data.lifterMap;
                        if (lifterItemsStr) {
                            var funcItem = {};
                            for (var i in lifterItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = lifterItemsStr[i];
                                this.lifterItems.push(funcItem);
                            }
                        }
                        var specialItemsStr = res.data.specialMap;
                        if (specialItemsStr) {
                            var funcItem = {};
                            for (var i in specialItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text = i;
                                funcItem.quality = specialItemsStr[i];
                                this.specialItems.push(funcItem);
                            }
                        }
                        var componentItemsStr = res.data.componentMap;
                        if (componentItemsStr) {
                            var funcItem = {};
                            for (var i in componentItemsStr) {
                                funcItem = {text: '', quality: 0}
                                funcItem.text =  i;
                                funcItem.quality = componentItemsStr[i];
                                this.componentItems.push(funcItem);
                            }
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            handleCheckAllChange(val) {
                this.contractForm.demand = val ? this.functions : [];
                this.isIndeterminate = false;
            },
            handleCheckedFunctionsChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.functions.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.functions.length;
            },
            resetBtn() {
                this.searchItem = {
                    contractNum: '',
                    userName: '',
                    userTel: '',
                    companyName: '',
                    companyType: '',
                    contractType: '',
                    auditState: '',
                    projectName: '',
                    startDate: '',
                    endDate: '',
                    pageSize: 14,
                    pageIndex: 1
                }
                this.searchBtn();
            },
            getSaleList(){

            }
        },
        created() {
            this.tableHeight = (window.innerHeight) * 0.67
            this.searchBtn();
            this.$api.getSaleList().then(res => {
                if (res.code == 200){
                    this.saleList = res.data
                }
            })
            this.jsonFields.map((item, i) => {
                this.json_fields[item.label] = item.prop
            })
            this.json_data = contract.data;
            this.shippingData = shipping.data;
            this.functions = funOptions.data;
            if (window.screen.height > 900) {
                this.lineHeight = window.screen.height * 0.038 + 'px';
            } else {
                this.lineHeight = window.screen.height * 0.033 + 'px';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .text-title {
        font-size: 16px;
        font-weight: bold;
        color: #437EE6;
        text-align: center;
        margin-bottom: 20px;
    }

    .dialog-body {
        max-height: 650px;
        overflow-y: scroll;
    }

    .opertion {
        display: flex;
        justify-content: center;
    }

    .iconfont {
        font-family: "iconfont" !important;
        font-size: 20px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-top: 3px;
        display: block;
        cursor: pointer;
    }

    .iconbianji {
        color: #20a0ff;
        margin-left: 10%;
    }

    .icontongguo {
        color: green;
        margin-left: 17%;
    }

    .iconbohui {
        color: red;
        margin-left: 10%;
    }

    .iconxiangqing {
        margin-left: 17%;
    }

    .page-body {
        background-color: #FFFFFF;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .table-body {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .table-header {
        height: 16.5%;
        background-color: #FFFFFF;
    }

    .handle-box {
        padding: 10px;
    }

    .table-info {
        height: 82%;
        margin-top: 8px;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
    }

    .table-button {
        flex: 1;
        margin: 0 10px;
    }

    .table-data {
        height: 6%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .handle-input {
        display: inline-block;
    }

    .handle-input-date {
        width: 150px;
        display: inline-block;
        padding-right: 0px;
    }

    .information {
        background-color: #F0F2F5;
    }

    .dialog-title {
        margin: 0 20px;
        color: #67ADD9;
        font-size: 20px;
        /*border: 1px red solid;*/
    }

    .payment-table, .approval-table, .file-info {
        margin-top: 50px;
    }

    .basic-info .el-button {
        background: linear-gradient(to bottom, #39AACE, #E1E3E3);
        border: 1px blue solid;
    }

    .payment-table .el-button {
        border: 1px green solid;
        background: linear-gradient(to bottom, #39AACE, #E1E3E3);
    }

    .approval-table .el-button {
        border: 1px black solid;
        background: linear-gradient(to bottom, #39AACE, #E1E3E3);
    }

    .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }

    .td-body {
        padding: 10px 0;
        white-space: nowrap;
        overflow-x: scroll;
        width: 1100px;
    }

    td {
        white-space: nowrap; /*控制单行显示*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*隐藏的字符用省略号表示*/
    }

    .upload-files {
        margin-top: 50px;
    }

    .file-type {
        margin-top: 10px;
        width: 100%;
        display: flex;
    }

    .file-list {
        width: 100%;
        display: flex;
        margin-left: 10px;
    }

    .el-table--scrollable-x .el-table__body-wrapper {
        overflow: auto !important;
    }
</style>
